import { render, staticRenderFns } from "./ServicosMainPanel.vue?vue&type=template&id=8057adc0&scoped=true&"
import script from "./ServicosMainPanel.vue?vue&type=script&lang=js&"
export * from "./ServicosMainPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8057adc0",
  null
  
)

export default component.exports